<script>
  import Button from '@components/buttons/button.svelte'
  import Dropdown from '@components/general/dropdown.svelte'
  import { Link, page } from '@inertiajs/svelte'
  import { ChevronRight, Settings } from 'lucide-svelte'
  import { cn } from '@lib/utils'

  let { links = [], includeHome = true, title, Icon, class: className, adminLink, adminActions, adminArea } = $props()

  let user = $derived($page.props.user)

  let showAdminActions = $derived(adminActions && user?.is_admin)
</script>

{#snippet link(item)}
  <li>
    <Link href={item.href} class="text-gray-600/80 text-xs sm:text-sm font-medium sm:font-normal hover:text-gray-700 hover:underline whitespace-nowrap">{item.text}</Link>
  </li>
{/snippet}

<section class={cn("flex items-center gap-3 px-4 py-3 sm:px-8 sm:py-4 border-b border-gray-200 overflow-x-auto", className)} role="navigation">

  {#if Icon}
    <Icon size={16} strokeWidth={1.5} class="text-gray-600 shrink-0" />
  {/if}

  <ul class="flex items-center gap-1 min-w-0">

    <!-- Home -->
    {#if includeHome}
      {@render link({ href: "/", text: "Home" })}
      <ChevronRight size={14} strokeWidth={1.5} />
    {/if}

    <!-- Links -->
    {#each links as item (item.text)}
      {@render link(item)}
      <ChevronRight size={14} strokeWidth={1.5} />
    {/each}

    <!-- Title -->
    <li class="text-gray-400 text-xs sm:text-sm truncate min-w-0">
      <span class={"text-gray-700/80"}>{title}</span>
    </li>
  </ul>

  <div class="ml-auto flex gap-2">

    {#if user?.is_admin && adminArea}
      {@render adminArea()}
    {/if}

    {#if showAdminActions}

      {#if adminActions.length > 2}
        <Dropdown text="Admin actions" width="14rem" align="end" buttonProps={{ text: "Admin", variant: "outline", Icon: Settings }}>
          {#snippet contents(item)}
            {#each adminActions as action (action.text)}
              {@render item(action)}
            {/each}
          {/snippet}
        </Dropdown>
      {:else}
        {#each adminActions as action (action.text)}
          <Button variant="outline" Icon={action.icon} text={action.text} onclick={action.onSelect} path={action.path} />
        {/each}
      {/if}
    {/if}
  
  </div>

</section>